import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';

const EmployerProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  // Mock data - replace with actual API call
  const employer = {
    id: 'EMP-001',
    companyName: 'TechCorp Inc.',
    tagline: 'Building the Future of Technology',
    description: 'TechCorp is a leading technology company specializing in innovative software solutions for businesses worldwide. Founded in 2015, we have grown to become a trusted partner for organizations seeking digital transformation.',
    
    // Basic Info
    industry: 'Technology & Software Development',
    employeeSize: '201-500 employees',
    founded: '2015',
    headquarters: 'New York, NY, USA',
    website: 'https://techcorp.com',
    contactEmail: 'careers@techcorp.com',
    phone: '+1 (555) 123-4567',
    
    // Social Media
    linkedin: 'https://linkedin.com/company/techcorp',
    twitter: 'https://twitter.com/techcorp',
    facebook: 'https://facebook.com/techcorp',
    github: 'https://github.com/techcorp',
    
    // Company Details
    mission: 'To empower businesses with cutting-edge technology solutions that drive growth and efficiency while fostering innovation and collaboration.',
    vision: 'To be the world\'s most trusted technology partner, transforming how businesses operate and thrive in the digital age.',
    values: [
      'Innovation: We embrace change and continuously seek better solutions',
      'Excellence: We strive for the highest quality in everything we do',
      'Collaboration: We believe in the power of teamwork',
      'Integrity: We conduct business with honesty and transparency',
      'Growth: We invest in our people and their development'
    ],
    
    // Culture & Benefits
    culture: 'At TechCorp, we foster a collaborative and inclusive environment where innovation thrives. We believe in work-life balance and provide our team with the tools and flexibility they need to succeed.',
    benefits: [
      'Competitive salary and equity packages',
      'Comprehensive health, dental, and vision insurance',
      'Flexible work arrangements (remote & hybrid options)',
      'Professional development budget ($5,000/year)',
      '401(k) with 4% company matching',
      'Unlimited PTO and paid parental leave',
      'Latest hardware and tools',
      'Wellness programs and gym memberships',
      'Regular team events and retreats',
      'Learning and certification opportunities'
    ],
    
    // Team & Leadership
    team: [
      { name: 'Sarah Johnson', position: 'CEO & Founder', bio: 'Former Google engineer with 15+ years in tech' },
      { name: 'Michael Chen', position: 'CTO', bio: 'Expert in cloud architecture and scalable systems' },
      { name: 'Emily Davis', position: 'Head of Engineering', bio: 'Passionate about building high-performing teams' },
      { name: 'David Wilson', position: 'Head of Product', bio: 'Product strategist with focus on user experience' }
    ],
    
    // Statistics
    stats: {
      totalJobs: 45,
      activeJobs: 12,
      avgHiringTime: '2 weeks',
      employeeRetention: '92%',
      candidateSatisfaction: '4.8/5'
    },
    
    // Technologies
    technologies: ['React', 'Node.js', 'Python', 'AWS', 'TypeScript', 'Docker', 'Kubernetes', 'MongoDB', 'PostgreSQL', 'GraphQL'],
    
    // Recent Awards
    awards: [
      { year: '2023', award: 'Best Tech Workplace - Tech Awards' },
      { year: '2023', award: 'Top 100 Companies to Work For - Business Magazine' },
      { year: '2022', award: 'Innovation Excellence Award - Tech Summit' },
      { year: '2022', award: 'Fastest Growing Company - Startup Weekly' }
    ],
    
    // Logo and Media
    logo: '/api/placeholder/120/120',
    coverImage: '/api/placeholder/1200/300',
    
    // Open Jobs
    openJobs: [
      { id: 1, title: 'Senior Frontend Developer', department: 'Engineering', type: 'Full-time', location: 'New York, NY', remote: 'Hybrid', salary: '$120,000 - $150,000', posted: '2 days ago' },
      { id: 2, title: 'DevOps Engineer', department: 'Engineering', type: 'Full-time', location: 'Remote', remote: 'Remote', salary: '$110,000 - $140,000', posted: '5 days ago' },
      { id: 3, title: 'Product Manager', department: 'Product', type: 'Full-time', location: 'San Francisco, CA', remote: 'Hybrid', salary: '$130,000 - $160,000', posted: '1 week ago' },
      { id: 4, title: 'UX Designer', department: 'Design', type: 'Full-time', location: 'New York, NY', remote: 'On-site', salary: '$90,000 - $120,000', posted: '3 days ago' }
    ]
  };

  const tabs = [
    { id: 'overview', label: 'Overview', icon: 'fas fa-building' },
    { id: 'jobs', label: 'Open Jobs', icon: 'fas fa-briefcase' },
    { id: 'culture', label: 'Culture', icon: 'fas fa-users' },
    { id: 'team', label: 'Team', icon: 'fas fa-user-tie' },
    { id: 'reviews', label: 'Reviews', icon: 'fas fa-star' }
  ];

  const handleExternalApply = (jobUrl) => {
    window.open(jobUrl, '_blank', 'noopener,noreferrer');
  };

  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div>
      {/* Header with Back Button */}
      <div className="mb-6">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-gray-600 hover:text-gray-800 mb-4"
        >
          <i className="fas fa-arrow-left mr-2"></i>
          Back to Job
        </button>
      </div>

      {/* Company Header - Clean Version */}
      {/* <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6 border border-gray-200">
        <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-8 border-b border-gray-200">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="flex items-center space-x-6">
              <div className="h-20 w-20 rounded-2xl bg-white p-2 shadow-md border border-gray-200">
                <div className="h-full w-full rounded-xl bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold text-xl">
                  {employer.companyName.charAt(0)}
                </div>
              </div>
              <div>
                <h1 className="text-3xl font-bold text-gray-800 mb-2">{employer.companyName}</h1>
                <p className="text-xl text-gray-600 mb-3">{employer.tagline}</p>
                <div className="flex flex-wrap gap-2">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-white text-gray-700 border border-gray-300">
                    <i className="fas fa-industry mr-1 text-xs"></i>
                    {employer.industry}
                  </span>
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-white text-gray-700 border border-gray-300">
                    <i className="fas fa-users mr-1 text-xs"></i>
                    {employer.employeeSize}
                  </span>
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-white text-gray-700 border border-gray-300">
                    <i className="fas fa-map-marker-alt mr-1 text-xs"></i>
                    {employer.headquarters}
                  </span>
                </div>
              </div>
            </div>
            
            <div className="flex space-x-3 mt-4 md:mt-0">
              <button className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 flex items-center text-sm font-medium">
                <i className="fas fa-bookmark mr-2"></i>
                Follow Company
              </button>
              <button className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center text-sm">
                <i className="fas fa-share-alt mr-2"></i>
                Share
              </button>
            </div>
          </div>
        </div>
        
        <div className="px-6 py-4 bg-gray-50">
          <div className="flex flex-wrap gap-4 text-sm text-gray-600">
            <div className="flex items-center">
              <i className="fas fa-globe mr-2 text-gray-400"></i>
              <a href={employer.website} className="text-primary-600 hover:text-primary-700">
                {employer.website}
              </a>
            </div>
            <div className="flex items-center">
              <i className="fas fa-envelope mr-2 text-gray-400"></i>
              <span>{employer.contactEmail}</span>
            </div>
            <div className="flex items-center">
              <i className="fas fa-calendar mr-2 text-gray-400"></i>
              <span>Founded {employer.founded}</span>
            </div>
          </div>
        </div>
      </div> */}

      {/* Company Header - Professional Style */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6">
        {/* Main Header with Brand Colors */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-8 text-white ">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="flex items-center space-x-6">
              <div className="h-24 w-24 rounded-2xl bg-white p-2 shadow-lg">
                <div className="h-full w-full rounded-xl bg-white flex items-center justify-center text-blue-600 font-bold text-2xl">
                  {employer.companyName.charAt(0)}
                </div>
              </div>
              <div>
                <h1 className="text-4xl font-bold mb-2">{employer.companyName}</h1>
                <p className="text-xl text-blue-100 mb-4">{employer.tagline}</p>
                <div className="flex flex-wrap gap-2">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-500 text-white">
                    <i className="fas fa-industry mr-1"></i>
                    {employer.industry}
                  </span>
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-500 text-white">
                    <i className="fas fa-users mr-1"></i>
                    {employer.employeeSize}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Secondary Info Bar */}
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-2 md:mb-0">
              <div className="flex items-center">
                <i className="fas fa-map-marker-alt mr-2 text-gray-400"></i>
                <span className="font-medium">{employer.headquarters}</span>
              </div>
              <div className="flex items-center">
                <i className="fas fa-calendar mr-2 text-gray-400"></i>
                <span>Since {employer.founded}</span>
              </div>
              <div className="flex items-center">
                <i className="fas fa-globe mr-2 text-gray-400"></i>
                <a href={employer.website} className="text-primary-600 hover:text-primary-700 font-medium">
                  Visit Website
                </a>
              </div>
            </div>
            
            {/* Action Buttons */}
            <div className="flex space-x-3">
              <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center text-sm font-medium shadow-sm">
                <i className="fas fa-bookmark mr-2"></i>
                Follow
              </button>
              <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center text-sm font-medium shadow-sm">
                <i className="fas fa-share-alt mr-2"></i>
                Share
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        {/* Main Content */}
        <div className="lg:w-3/4">
          {/* Navigation Tabs */}
          <div className="bg-white rounded-xl shadow-sm mb-6">
            <div className="border-b border-gray-200">
              <nav className="flex space-x-8 px-6" aria-label="Tabs">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center py-4 px-1 border-b-2 font-medium text-sm ${
                      activeTab === tab.id
                        ? 'border-primary-500 text-primary-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <i className={`${tab.icon} mr-2`}></i>
                    {tab.label}
                  </button>
                ))}
              </nav>
            </div>

            {/* Tab Content */}
            <div className="p-6">
              {/* Overview Tab */}
              {activeTab === 'overview' && (
                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">About Us</h3>
                    <p className="text-gray-600 leading-relaxed">{employer.description}</p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h4 className="font-semibold text-gray-800 mb-3">Our Mission</h4>
                      <p className="text-gray-400">{employer.mission}</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 mb-3">Our Vision</h4>
                      <p className="text-gray-400">{employer.vision}</p>
                    </div>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800 mb-3">Core Values</h4>
                    <ul className="space-y-2">
                      {employer.values.map((value, index) => (
                        <li key={index} className="flex items-start text-gray-600">
                          <i className="fas fa-check text-green-500 mt-1 mr-3"></i>
                          {value}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800 mb-3">Technologies We Use</h4>
                    <div className="flex flex-wrap gap-2">
                      {employer.technologies.map((tech, index) => (
                        <span key={index} className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800 mb-3">Awards & Recognition</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {employer.awards.map((award, index) => (
                        <div key={index} className="flex items-center p-3 border border-gray-200 rounded-lg">
                          <div className="bg-primary-100 text-primary-600 px-3 py-1 rounded-lg mr-4">
                            <span className="font-semibold">{award.year}</span>
                          </div>
                          <span className="text-gray-700">{award.award}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Jobs Tab */}
              {activeTab === 'jobs' && (
                <div>
                  <div className="flex justify-between items-center mb-6">
                    <h3 className="text-lg font-semibold text-gray-800">
                      Open Positions ({employer.openJobs.length})
                    </h3>
                    <div className="flex items-center space-x-2">
                      <span className="text-sm text-gray-600">Sort by:</span>
                      <select className="text-sm border border-gray-300 rounded-lg px-3 py-1 focus:outline-none focus:ring-2 focus:ring-primary-500">
                        <option>Most Relevant</option>
                        <option>Newest</option>
                        <option>Salary: High to Low</option>
                      </select>
                    </div>
                  </div>

                  <div className="space-y-4">
                    {employer.openJobs.map((job) => (
                      <div key={job.id} className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
                        <div className="flex justify-between items-start mb-3">
                          <div className="flex-1">
                            <Link 
                              to={`/candidate/jobs/${job.id}`}
                              className="text-lg font-semibold text-gray-800 hover:text-primary-600"
                            >
                              {job.title}
                            </Link>
                            <div className="flex flex-wrap gap-2 mt-2">
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                <i className="fas fa-briefcase mr-1"></i>
                                {job.department}
                              </span>
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                <i className="fas fa-clock mr-1"></i>
                                {job.type}
                              </span>
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                <i className="fas fa-location-arrow mr-1"></i>
                                {job.remote}
                              </span>
                            </div>
                          </div>
                          <div className="text-right">
                            <p className="text-lg font-semibold text-gray-800">{job.salary}</p>
                            <p className="text-sm text-gray-500">{job.posted}</p>
                          </div>
                        </div>
                        
                        <div className="flex justify-between items-center pt-3 border-t border-gray-200">
                          <div className="text-sm text-gray-600">
                            <i className="fas fa-map-marker-alt mr-1"></i>
                            {job.location}
                          </div>
                          <div className="flex space-x-2">
                            <button className="p-2 text-gray-400 hover:text-gray-600">
                              <i className="fas fa-bookmark"></i>
                            </button>
                            <button 
                              onClick={() => handleExternalApply(`https://example.com/apply/${job.id}`)}
                              className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 text-sm font-medium"
                            >
                              Apply Now
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Culture Tab */}
              {activeTab === 'culture' && (
                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">Work Culture</h3>
                    <p className="text-gray-600 leading-relaxed">{employer.culture}</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">Employee Benefits</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {employer.benefits.map((benefit, index) => (
                        <div key={index} className="flex items-start p-3 border border-gray-200 rounded-lg">
                          <i className="fas fa-check text-green-500 mt-1 mr-3"></i>
                          <span className="text-gray-700">{benefit}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="text-center p-4 bg-blue-50 rounded-lg">
                      <div className="text-2xl font-bold text-blue-600">{employer.stats.employeeRetention}</div>
                      <div className="text-sm text-blue-600">Employee Retention</div>
                    </div>
                    <div className="text-center p-4 bg-green-50 rounded-lg">
                      <div className="text-2xl font-bold text-green-600">{employer.stats.candidateSatisfaction}</div>
                      <div className="text-sm text-green-600">Candidate Satisfaction</div>
                    </div>
                    <div className="text-center p-4 bg-purple-50 rounded-lg">
                      <div className="text-2xl font-bold text-purple-600">{formatNumber(employer.stats.totalJobs)}</div>
                      <div className="text-sm text-purple-600">Total Jobs Posted</div>
                    </div>
                    <div className="text-center p-4 bg-orange-50 rounded-lg">
                      <div className="text-2xl font-bold text-orange-600">{employer.stats.avgHiringTime}</div>
                      <div className="text-sm text-orange-600">Avg. Hiring Time</div>
                    </div>
                  </div>
                </div>
              )}

              {/* Team Tab */}
              {activeTab === 'team' && (
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-6">Leadership Team</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {employer.team.map((member, index) => (
                      <div key={index} className="flex items-start space-x-4 p-4 border border-gray-200 rounded-lg">
                        <div className="h-16 w-16 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white font-semibold text-lg">
                          {member.name.charAt(0)}
                        </div>
                        <div>
                          <h4 className="font-semibold text-gray-800">{member.name}</h4>
                          <p className="text-primary-600 font-medium">{member.position}</p>
                          <p className="text-gray-600 text-sm mt-1">{member.bio}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Reviews Tab */}
              {activeTab === 'reviews' && (
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-6">Employee Reviews</h3>
                  <div className="text-center py-12">
                    <i className="fas fa-comments text-4xl text-gray-300 mb-4"></i>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">No Reviews Yet</h4>
                    <p className="text-gray-400">Be the first to review this company after your interview process.</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="lg:w-1/4">
          <div className="space-y-6">
            {/* Contact Information */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Contact Information</h3>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="fas fa-globe text-gray-400 w-5 mr-3"></i>
                  <a href={employer.website} className="text-primary-600 hover:text-primary-700 text-sm">
                    {employer.website}
                  </a>
                </div>
                <div className="flex items-center">
                  <i className="fas fa-envelope text-gray-400 w-5 mr-3"></i>
                  <span className="text-gray-600 text-sm">{employer.contactEmail}</span>
                </div>
                <div className="flex items-center">
                  <i className="fas fa-phone text-gray-400 w-5 mr-3"></i>
                  <span className="text-gray-600 text-sm">{employer.phone}</span>
                </div>
                <div className="flex items-center">
                  <i className="fas fa-map-marker-alt text-gray-400 w-5 mr-3"></i>
                  <span className="text-gray-600 text-sm">{employer.headquarters}</span>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Follow Us</h3>
              <div className="flex space-x-3">
                {employer.linkedin && (
                  <a href={employer.linkedin} className="p-2 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200">
                    <i className="fab fa-linkedin"></i>
                  </a>
                )}
                {employer.twitter && (
                  <a href={employer.twitter} className="p-2 bg-blue-100 text-blue-400 rounded-lg hover:bg-blue-200">
                    <i className="fab fa-twitter"></i>
                  </a>
                )}
                {employer.facebook && (
                  <a href={employer.facebook} className="p-2 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200">
                    <i className="fab fa-facebook"></i>
                  </a>
                )}
                {employer.github && (
                  <a href={employer.github} className="p-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200">
                    <i className="fab fa-github"></i>
                  </a>
                )}
              </div>
            </div>

            {/* AI Insights */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">AI Career Insights</h3>
              <div className="space-y-3">
                <div className="flex items-start">
                  <i className="fas fa-lightbulb text-yellow-500 mt-1 mr-3"></i>
                  <p className="text-sm text-gray-600">
                    This company has a high employee satisfaction rate and strong growth trajectory.
                  </p>
                </div>
                <div className="flex items-start">
                  <i className="fas fa-chart-line text-green-500 mt-1 mr-3"></i>
                  <p className="text-sm text-gray-600">
                    They're actively hiring and have a fast interview process.
                  </p>
                </div>
                <div className="flex items-start">
                  <i className="fas fa-award text-blue-500 mt-1 mr-3"></i>
                  <p className="text-sm text-gray-600">
                    Recognized for excellent workplace culture and innovation.
                  </p>
                </div>
              </div>
              <Link 
                to="/candidate/ai-assistant"
                className="block mt-4 w-full text-center py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:shadow-lg transition-shadow font-medium text-sm"
              >
                <i className="fas fa-robot mr-2"></i>
                Get Personalized Advice
              </Link>
            </div>

            {/* Similar Companies */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Similar Companies</h3>
              <div className="space-y-3">
                {['TechStart Inc.', 'Innovate Labs', 'Digital Solutions', 'CodeCraft'].map((company, index) => (
                  <div key={index} className="flex items-center p-2 hover:bg-gray-50 rounded-lg cursor-pointer">
                    <div className="h-8 w-8 rounded-lg bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white font-semibold text-xs mr-3">
                      {company.charAt(0)}
                    </div>
                    <span className="text-sm text-gray-700">{company}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployerProfile;